import { render } from "./SellerAvatarGroup.vue?vue&type=template&id=49fad601"
import script from "./SellerAvatarGroup.vue?vue&type=script&lang=js"
export * from "./SellerAvatarGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__